import { useTranslations } from "next-intl";
import catalogContexts from "@utils/constants/catalogContexts";
import Image from "@components/core/Image";

function NoProductException({ isSearchOnLikedProductNoResults, context }) {
  const t = useTranslations("catalog");

  if ([catalogContexts.wishlist, catalogContexts.userlist].includes(context)) {
    const imgSrc = isSearchOnLikedProductNoResults ? "closetDark" : "bonusNeon";
    const altText = isSearchOnLikedProductNoResults ? "closet_dark_alt" : "bonus_neon_alt";
    const listState = isSearchOnLikedProductNoResults ? "full" : "empty";
    const title = t(`no_results.${context}.${listState}.title`);
    const subtitle = t(`no_results.${context}.${listState}.subtitle`);

    return (
      <div className="d-flex flex-column align-items-center">
        <div className="no-products-exception">
          <div className="image-container">
            <Image
              src={imgSrc}
              alt={altText}
              className="h-100"
            />
          </div>
          <p className="mb-2 text-center font-weight-bold">{title}</p>
          <p className="mb-0 text-center">{subtitle}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-5 pb-6">
      <p className="text-center mb-0">{t("no_products_exception")}</p>
    </div>
  );
}

export default NoProductException;
